import styled from "@emotion/styled";
import { NavbarButton } from "./NavbarButton";
import { WavyHamburger, WavyHamburgerExpanded } from "components/Icons";
import { useEffect, useRef } from "react";
import { NavbarLinkItem } from "./NavbarLinkItem";
import { linkItems } from "../NavbarV2Desktop";
import { css } from "@emotion/react";
import { GlobalStore } from "store/global/GlobalStore";
import { Theme } from "styles/theme";
import { useHover } from "usehooks-ts";

interface NavbarLinksProps {
  closeProfileActions: () => void;
}

export const NavbarLinks = ({ closeProfileActions }: NavbarLinksProps) => {
  const buttonRef = useRef<HTMLDivElement>(null);
  const isHover = useHover(buttonRef);
  const theme = GlobalStore.useState(s => s.theme);

  useEffect(() => {
    if (isHover) {
      closeProfileActions();
    }
  }, [closeProfileActions, isHover]);

  return (
    <NavbarLinksContainer isHover={isHover} ref={buttonRef}>
      <div>
        <NavbarButton
          symbol={{
            active: WavyHamburgerExpanded,
            // Show expanded hamburger as long as the user is hovering within
            // the popup content
            default: isHover ? WavyHamburgerExpanded : WavyHamburger,
          }}
          text="More"
          css={getNavbarButtonCss(theme, isHover)}
          colors={{ hover: theme["Brand colours"].Sea }}
        />
        <PopupContainer isHover={isHover}>
          {linkItems.map(item => (
            <NavbarLinkItem key={item.text} {...item} />
          ))}
        </PopupContainer>
      </div>
    </NavbarLinksContainer>
  );
};

// Sub-components

const NavbarLinksContainer = styled.div<{ isHover: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 200%;
  height: 70%;
`;

const PopupContainer = styled.div<{ isHover: boolean }>`
  display: ${props => (props.isHover ? "flex" : "none")};
  flex-direction: column;
  width: 250px;
  position: absolute;
  left: 184px;
  top: 20px;
  padding: 8px;
  align-items: flex-start;
  border-radius: 20px;
  background: ${props => props.theme.surface.main.primary.hover};
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.25);
  opacity: 0.5;
  animation: slide 0.25s ease-in-out forwards;

  @keyframes slide {
    100% {
      top: 0;
      opacity: 1;
    }
  }
`;

// Helpers

export const getNavbarButtonCss = (theme: Theme, isHover: boolean) => css`
  color: ${isHover ? theme["Brand colours"].Sea : theme.font.secondary.default};
  pointer-events: none;
  font-size: ${theme.fontSize[5]};
`;
